<template>
  <div class="main-contant">
    <el-row>
      <el-col :span="6">
        <div class="setps-area">
          <div style="height: 300px">
            <el-steps direction="vertical" :active="setepInfoData.currentStepNum" space="30%" :align-center="true"
              class="steps">
              <div v-if="setepInfoData.currentStepName == 'apply' || setepInfoData.currentStepName == 'continue'">
                <el-step class="step-titile" v-for="(item, index) in applySetpList" :key="'st1'+index">
                  <div slot="title">
                    <span v-html="item" />
                  </div>
                  <template slot="icon">
                    <img v-if="setepInfoData.currentStepNum == index" class="setp-icon"
                      src="../../assets/icon/loading.png" />
                    <img v-else-if="setepInfoData.currentStepNum < index" class="setp-icon"
                      src="../../assets/icon/lutaib.png" />
                    <img v-else="setepInfoData.currentStepNum < index" class="setp-icon"
                      src="../../assets/icon/success_fill.png"></img>
                  </template>
                </el-step>
              </div>
              <div v-if="setepInfoData.currentStepName == 'query'">
                <el-step class="step-titile" v-for="(item, index) in querySetpList" :key="'st2'+index">
                  <div slot="title">
                    <span v-html="item" />
                  </div>
                  <template slot="icon">
                    <img v-if="setepInfoData.currentStepNum == index" class="setp-icon"
                      src="../../assets/icon/loading.png" />
                    <img v-else-if="setepInfoData.currentStepNum < index" class="setp-icon"
                      src="../../assets/icon/lutaib.png" />
                    <img v-else="setepInfoData.currentStepNum < index" class="setp-icon"
                      src="../../assets/icon/success_fill.png"></img>
                  </template>
                </el-step>
              </div>
            </el-steps>
          </div>
        </div>
      </el-col>
       <el-col :span="18">
        <!-- 这里显示右边表单区域 -->
        <router-view name="formData" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    watch: {
      'setepInfoData.currentOperateName'() {
        this.setepInfoData = this.$store.getters.querySetepInfo;
      },
    },
    data() {
      return {
        setepInfoData: this.$store.getters.querySetepInfo,
        applySetpList: [
          "第一步 Step 1：<br />開立申請帳戶<br /> Create Application Account",
          "第二步 Step 2：<br />個人資料<br /> Personal Information",
          "第三步 Step 3：<br />驗證電郵<br />Verify Email",
          "第四步 Step 4：<br />住屋、生活及工作資料<br />Housing, Living, and Employment Information",
          "第五步 Step 5：<br />申請資格聲明<br />Application Eligibility Declaration",
          "第六步 Step 6：<br />申報及上傳檔案<br />Declaration and File Upload",
          "第七步 Step 7：<br />聲明、條款及細則<br /> Declaration, Terms, and Conditions",
        ],
        querySetpList: [
          "第一步Step 1：<br>驗證電郵<br>",
          "第二步Step 2: <br> 查詢申請狀況<br>Application Status Enquiry",
        ],
      };
    },
    created() {
      this.setepInfoData = this.$store.getters.querySetepInfo;

    },


  };

</script>

<style>
  .main-contant {
    /* background-color: red; */
  }

  .setp-icon {
    width: 25px;
    height: 25px;
    margin-right: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Layout/index.vue